import { timefitBackend } from '../../Services/TimefitBackend';
import { useRecord } from '../useRecord/useRecord.ts';
import { keys } from '../../Services/Query/Keys.ts';

export function useCurrentUser() {
  const queryFn = () => timefitBackend.getCurrentUser();

  return useRecord(keys.users.current(), queryFn);
}
